import HelpOutline from "@mui/icons-material/HelpOutline";
import { IconButton, Tooltip } from "@mui/material";
import { useCurrentUser } from "hooks/useCurrentUser";
import { MouseEvent, ReactNode, SyntheticEvent, useState } from "react";

/**
 * The staff-only "why was this classified this way" affordance. Staff-gated
 * rather than flag-gated: `isStaff` is false while emulating a customer, and
 * the waste-rule-compliance-engine-ui flag stays a server-side gate until the
 * explanation is ready for customer eyes.
 */
export function ExplainClassificationButton({
  renderDialog,
}: {
  /** The host's explanation dialog, mounted only while open. */
  renderDialog: (onClose: () => void) => ReactNode;
}) {
  const { isStaff } = useCurrentUser();
  const [open, setOpen] = useState(false);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };
  // The dialog portals out of the cell, but React still bubbles its events
  // through the cell to the row.
  const stopPropagation = (event: SyntheticEvent) => event.stopPropagation();

  if (!isStaff) return null;

  return (
    <>
      <Tooltip title="Explain this classification">
        <IconButton
          size="small"
          color="staff"
          onClick={handleOpen}
          aria-label="Explain this classification"
        >
          <HelpOutline fontSize="small" />
        </IconButton>
      </Tooltip>
      {open && (
        <span onClick={stopPropagation} onDoubleClick={stopPropagation} onKeyDown={stopPropagation}>
          {renderDialog(() => setOpen(false))}
        </span>
      )}
    </>
  );
}
